import React, { useRef, useEffect, useState, cloneElement, useCallback } from "react";
import styled from "styled-components";

const ObserverDummyBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1000;
  transform: ${props => (props.isLastRows ? "scale(1, 10)" : "scale(1, 20)")};
  transform-origin: ${props => props.isLastRows && "center bottom"};
`;

const ObserverDummyBlockWrapper = (ref, isLastRows) => {
  return <ObserverDummyBlock ref={ref} isLastRows={isLastRows} />;
};

const GridRowsInViewPort = ({
  children,
  index,
  bottomIndexes,
  observer,
  focusedIndex,
  isLastSection,
  rowsDefaultVisiblityState,
  rowElementsWeakMap,
  setFocusedIndex = () => null
}) => {
  const observerRef = useRef();
  const [showRow, setShowRow] = useState(false);

  useEffect(() => {
    if (!observer) {
      return () => null;
    }
    const setItemVisibility = isIntersecting => {
      if (isIntersecting) {
        setShowRow(true);
      } else {
        const currentFocusedIndex = focusedIndex.current;
        setShowRow(
          currentFocusedIndex !== null
            ? [currentFocusedIndex - 1, currentFocusedIndex, currentFocusedIndex + 1].includes(index)
            : false
        );
      }
    };
    const currentElementRef = observerRef.current;
    rowElementsWeakMap.current.set(currentElementRef, setItemVisibility);
    observer.observe(currentElementRef);

    return () => {
      observer.unobserve(currentElementRef);
    };
  }, [observer]);

  const handleOnFocus = useCallback(() => {
    setFocusedIndex(index);
  }, []);

  const handleOnBlur = useCallback(() => {
    setFocusedIndex(null);
  }, []);

  const isLastRows = isLastSection && index > bottomIndexes;

  return cloneElement(children, {
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    showRow: rowsDefaultVisiblityState || showRow,
    observerDummyBlock: ObserverDummyBlockWrapper(observerRef, isLastRows)
  });
};

export default React.memo(GridRowsInViewPort);
